import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import {environment} from '../../../../environments/environment';
import {CookieService} from 'ngx-cookie';
declare var DDP_ENV: any;
@Injectable({
  providedIn: 'root'
})

@Injectable({
  providedIn: 'root'
})
export class ClientServiceService {
  readonly baseURL = DDP_ENV.userUrl;

  constructor(private _http: Http, private cookieService: CookieService) {}

  getAllClients(page, status, size, regexPattern) {
    console.log('Inside get users');
    return this._http.get(this.baseURL + '/client?page=' + page + '&status=' + status + '&size=' + size + '&regexPattern=' + regexPattern, this.buildHeaders());
  }

  getClientById(clientId) {
    console.log('Inside get Client getClients : ' + clientId);
    return this._http.get(this.baseURL + '/client/' + clientId, this.buildHeaders());
  }

  addUpdateClient(clientData) {
    if (clientData.id === '') {
      return this._http.post(this.baseURL + '/client/', clientData, this.buildHeaders());
    } else {
      return this._http.put(this.baseURL + '/client/' + clientData.id, clientData, this.buildHeaders());
    }
  }

  /* Construct a common header */
  private buildHeaders(): any {
    const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
    return new RequestOptions({ headers: headers });
  }

}
